export default "__VITE_ASSET__BV2k3TGq__"